// Utils/Api/ResendBusinessOtp.js
import { executePost } from "../ServiceMethods";

export const ResendBusinessOtp = async (data, cb) => {
  try {
    const res = await executePost(
      "/businessuser/resend-business-map-otp",
      data
    );
    return res.data;
  } catch (error) {
    cb && cb();
    return false;
  }
};
